import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ResizeService {
    private readonly TABLET_MIN_WIDTH = 960;
    private readonly TABLET_MAX_WIDTH = 1279;
    private resizeObserver: ResizeObserver;
    private widthSubject = new BehaviorSubject<number>(window.innerWidth);
    width$ = this.widthSubject.asObservable();
    isTablet$ = this.width$.pipe(
        map((width) => width >= this.TABLET_MIN_WIDTH && width <= this.TABLET_MAX_WIDTH),
        distinctUntilChanged()
    );

    constructor(private ngZone: NgZone) {
        this.resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                this.ngZone.run(() => {
                    this.widthSubject.next(entry.contentRect.width);
                });
            }
        });
        this.resizeObserver.observe(document.body);
    }

    get width(): number {
        return this.widthSubject.value;
    }

    get isTablet(): boolean {
        return this.width >= this.TABLET_MIN_WIDTH && this.width <= this.TABLET_MAX_WIDTH;
    }
}
